<template lang="pug">
  v-card.mx-auto(
    max-width="1200"
    flat
    color="transparent"
  )
    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Название"
            full-width
            v-model="nameModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Подпись под названием"
            full-width
            v-model="nameDescriptionModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Заголовок в описании"
            full-width
            v-model="headerModel"
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-text-field.headline(
            label="Описание"
            full-width
            v-model="descriptionModel"
          )

      v-row.mb-0(align="center") Можно загружать только картинки формата svg
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-img(
            v-if="image!==''"
            :src="image"
          )
        input(
          @change="onImageChanged($event)"
          accept="image/*"
          type="file"
        )
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    nameDescription: {
      type: String,
      default: null,
    },
    header: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
  methods: {
    onImageChanged(val) {
      this.$emit('imageChanged', val)
    },
  },
  computed: {
    nameModel: {
      get() {
        return this.name
      },

      set(val) {
        this.$emit('nameChanged', val)
      },
    },
    nameDescriptionModel: {
      get() {
        return this.nameDescription
      },

      set(val) {
        this.$emit('nameDescriptionChanged', val)
      },
    },
    headerModel: {
      get() {
        return this.header
      },

      set(val) {
        this.$emit('headerChanged', val)
      },
    },
    descriptionModel: {
      get() {
        return this.description
      },

      set(val) {
        this.$emit('descriptionChanged', val)
      },
    },
  },

}
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 400px;
}
</style>
